// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Amplify } from '@aws-amplify/core';
import { getUrl as getUrlInternal } from './internal/getUrl';
export function getUrl(input) {
    return getUrlInternal(Amplify, input);
}
